module.exports = __webpack_public_path__ + "static/media/g2.0ec24cd1.svg";